// addMessageTranslationThrottleId.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import getOperationData from '../selector/getOperationData.js';

/**
 * Add message translation throttle id
 * @kind action
 * @param {string} {messageId} - api throttled query id.
 * @param {string} {userId} - user id.
 * @return {Promise} Action promise.
 */
const addMessageTranslationThrottleId =
  ({ messageId, userId }) =>
  async (dispatch, getState) => {
    const groups = [];
    if (messageId) {
      groups.push(`message-${messageId}`);
    }
    if (userId) {
      groups.push(`user-${userId}`);
    }
    const currentGroups =
      getOperationData(getState(), ['throttledMessageTranslation'], 'groups') ||
      [];

    const newGroups = [...new Set([...currentGroups, ...groups])];
    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['throttledMessageTranslation'],
        data: { groups: newGroups },
      },
    });
  };

export default addMessageTranslationThrottleId;
